import { render, staticRenderFns } from "./units.vue?vue&type=template&id=008ec3de"
import script from "./units.vue?vue&type=script&lang=js"
export * from "./units.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports